import { AddressbarColor } from 'quasar'

export default () => {
  // AddressbarColor.set('#a2e3fa')
  AddressbarColor.set('#ffffff')
}
